<template>
  <div class="grid-x bs-info">
    <div class="cell grid-x input">
      <div class="cell small-4 reg">
        <label for="registrationNumber" data-test="registrationNumber-label" v-text="texts.registrationNumber" />
        <Field
          v-model="modelValueData.registrationNumber"
          :rules="'required|numeric|digits:4|validate_reg_number'"
          data-test="registrationNumber"
          type="text"
          name="registrationNumber"
          label="Reg. nummer"
          maxlength="4"
          @input="emit('registrationNumber')"
        />
        <ValidationError name="registrationNumber" data-test-error="registrationNumber" />
      </div>

      <div class="cell small-8">
        <label for="accountNumber" data-test="accountNumber-label" v-text="texts.accountNumber" />

        <Field
          v-model="modelValueData.accountNumber"
          :rules="'required|numeric|digits:10'"
          data-test="accountNumber"
          type="text"
          name="accountNumber"
          label="Kontonummeret"
          maxlength="10"
          @input="emit('accountNumber')"
        />
        <ValidationError
          name="accountNumber"
          data-test-error="accountNumber"
          :overrides="{ digits: texts.accountNumberError }"
        />
      </div>
      <div v-if="regCheckMessage" data-test-regnr="found">
        <div v-text="regCheckMessage.Navn" />
        <div v-text="regCheckMessage.Afdeling" />
        <div v-text="regCheckMessage.Område" />
      </div>
    </div>
    <img src="/static/img/betalingsservice_pos_RGB.png" data-test="bs-image" class="" />
  </div>
</template>
<script>
import BaseMixinVue from '@/components/Feature/BaseMixin.vue';
import { defineRule, FormContextKey } from 'vee-validate';
import { inject } from 'vue';

import regnr from '@/static/regnr.json';

export default {
  name: 'BetalingsService',
  mixins: [BaseMixinVue],
  props: {
    modelValue: {
      type: Object,
      default() {
        return {
          accountNumber: null,
          registrationNumber: null
        };
      }
    },
    texts: {
      type: Object,
      default() {
        return {
          accountNumberError: 'Kontonummeret skal indeholde 10 cifre. Du skal evt. indtaste foranstillede nuller.',
          accountNumber: 'Kontonr.',
          registrationNumber: 'Reg.nr.',
          regCheck: 'Reg.nr. er ugyldigt. Prøv igen.'
        };
      }
    }
  },
  setup() {
    return { form: inject(FormContextKey, undefined) };
  },
  data() {
    return {
      regData: [],
      regCheckMessage: '',
      createdHookExecuted: false,
      modelValueData: this.modelValue
    };
  },

  watch: {
    'modelValueData.registrationNumber': function (val) {
      if (val.length === 4) {
        const found = this.checkReg(val);
        if (found) {
          this.regCheckMessage = found[0];
        } else {
          this.regCheckMessage = undefined;
        }
      } else {
        this.regCheckMessage = undefined;
      }
    }
  },

  created() {
    if (!this.createdHookExecuted) {
      this.regData = regnr;
      defineRule('validate_reg_number', (value) => {
        const isValid = this.checkReg(value).length > 0;
        return isValid ? true : 'Ukendt reg. nr.';
      });
      this.createdHookExecuted = true;
    }
  },

  methods: {
    async emit() {
      const vm = this;
      vm.$emit('update:modelValue', vm.modelValueData);
    },
    checkReg(value) {
      return this.regData.filter((element) => element.Registreringsnummer === value);
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

img {
  height: rem-calc(19.5px);
}

label {
  padding-bottom: rem-calc(5px);
}

input {
  margin-bottom: 0;
  margin-right: 0;
  margin-left: 0;
}

.reg {
  padding-right: rem-calc(10px);
}

.input {
  padding-bottom: rem-calc(20px);
}
</style>
